import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Formik, Form } from "formik";

import { setBookingInfo, getBookingPricing } from "./actions";
import moment from "moment";
import FormikCheckboxCustom from "../../ui/FormikCheckboxCustom";
import FormikRadioButton from "../../ui/FormikRadioButton";
import PlusMinusNumber from "../../ui/PlusMinusNumber";

import { checkAuthorization } from "../../global/actions";
import { setSelectedListing } from "../../listings/actions";
import PlusMinusNumberCustom from "../../ui/PlusMinusNumberCustom";
import { getListingImage } from "../../../constants/util";

const mapStateToProps = (state) => ({
  booking: state.Booking,
  listing: state.BrowseListings.selectedListing,
  global: state.Global,
});

class BookingOptionsComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};

    this.onBack = this.onBack.bind(this);
    this.checkForRedirection = this.checkForRedirection.bind(this);
    this.mapAO = this.mapAO.bind(this);
    this.isStreamlineListing = this.isStreamlineListing.bind(this);
  }

  componentWillMount() {
    let { dispatch } = this.props;
    dispatch(checkAuthorization());
  }

  componentDidMount() {
    this.checkForRedirection();
    const elements = document.getElementsByClassName(
      "listing-booking-overview"
    );
    if (!!elements && elements.length) elements[0].scrollIntoView();
  }

  isStreamlineListing = () => {
    const { listing } = this.props;
    return !!listing.streamId;
  };

  checkForRedirection() {
    let { history, booking, global } = this.props;
    //If came here from a listing page, but nothing has been loaded, send back to listing
    if (
      !global.userId ||
      (window.location.hash.indexOf("/booking-options") >= 0 &&
        !booking.selectedBooking)
    ) {
      history.replace(
        window.location.hash.substr(
          1,
          window.location.hash.indexOf("/booking-options")
        )
      );
    }
  }

  onBack() {
    let { history } = this.props;
    history.goBack();
  }

  numberChange = (form, field, num) => {
    let newForm = form.values.booking;
    let newVal = newForm[field.name] + num;
    newVal = newVal < 1 ? 1 : newVal;
    newForm[field.name] = newVal;
    this.props.dispatch(setBookingInfo(newForm));
  };

  numberChangeInventory = (form, field, num, values, addOn) => {
    let { dispatch } = this.props;

    // get listing
    let listing = form.values.listing;

    // get mongo record
    let mongoRecord = listing.addOns.filter((x) => x._id === addOn._id)[0];
    if (mongoRecord.inventoryToRemove === mongoRecord.inventory && num === 1)
      return;
    if (mongoRecord.inventoryToRemove === 1 && num === -1) return;

    let newVal = mongoRecord.inventoryToRemove + num;
    mongoRecord.inventoryToRemove = newVal;

    if (mongoRecord.show) {
      let oneTimePricing = {
        description: mongoRecord.name,
        price: mongoRecord.price * mongoRecord.inventoryToRemove,
        count: mongoRecord.inventoryToRemove,
        resourceId: mongoRecord._id,
      };
      values.booking.selectedAddOns = values.booking.selectedAddOns.filter(
        (x) => x.resourceId !== mongoRecord._id
      );
      values.booking.selectedAddOns.push(oneTimePricing);
      dispatch(setBookingInfo(values.booking));
    } else {
      values.booking.selectedAddOns = values.booking.selectedAddOns.filter(
        (x) => x.resourceId !== mongoRecord._id
      );
    }

    // save new values
    this.props.dispatch(setSelectedListing(listing));

    setTimeout(() => {
      this.forceUpdate();
    }, 50);
  };

  onSubmit = (values, { setSubmitting }) => {
    let { dispatch, history } = this.props;
    dispatch(setBookingInfo(values.booking));
    setTimeout(() => {
      dispatch(getBookingPricing()).then(() => {
        history.push(
          "/listing/" + values.booking.listingId + "/booking-pricing"
        );
        setSubmitting(false);
      });
    }, 500);
  };

  checkBoxToggle = (listing, addOn, values) => {
    let { dispatch } = this.props;

    // get mongo record
    let mongoRecord = listing.addOns.filter((x) => x._id === addOn._id)[0];

    // apply value to temporary property - on first check of checkbox
    if (mongoRecord.show === undefined) {
      mongoRecord.show = true;
      mongoRecord.inventoryToRemove = 1;
      let oneTimePricing = {
        description: mongoRecord.name,
        price:
          mongoRecord.inventoryToRemove > 0
            ? mongoRecord.price * mongoRecord.inventoryToRemove
            : mongoRecord.price,
        count: mongoRecord.inventoryToRemove,
        resourceId: mongoRecord._id,
      };
      values.booking.selectedAddOns.push(oneTimePricing);
    } else {
      if (mongoRecord.show) {
        // remove addon entirely
        mongoRecord.show = false;

        values.booking.selectedAddOns = values.booking.selectedAddOns.filter(
          (x) => x.resourceId !== mongoRecord._id
        );
        dispatch(setBookingInfo(values.booking));
      } else if (!mongoRecord.show) {
        // remove and reapply addon
        mongoRecord.show = true;

        let oneTimePricing = {
          description: mongoRecord.name,
          price: mongoRecord.price * mongoRecord.inventoryToRemove,
          count: mongoRecord.inventoryToRemove,
          resourceId: mongoRecord._id,
        };

        values.booking.selectedAddOns = values.booking.selectedAddOns.filter(
          (x) => x.resourceId !== mongoRecord._id
        );
        values.booking.selectedAddOns.push(oneTimePricing);
        dispatch(setBookingInfo(values.booking));
      }
    }

    // save new values
    this.props.dispatch(setSelectedListing(listing));

    setTimeout(() => {
      this.forceUpdate();
    }, 50);
  };

  mapAOPartA = (ao, bookingStartDate, bookingEndDate) => {
    if (!ao.validDates) return false;

    if (ao.validDates.length === 0) {
      return true;
    } else {
      return ao.validDates.find((date) => {
        let startDate = moment(date.startDate);
        if (date.endDate === null) {
          return startDate.isBetween(
            bookingStartDate,
            bookingEndDate,
            "d",
            "[]"
          );
        } else {
          let endDate = moment(date.endDate);
          return (
            bookingStartDate.isBetween(startDate, endDate, "d", "[]") ||
            bookingEndDate.isBetween(startDate, endDate, "d", "[]") ||
            startDate.isBetween(bookingStartDate, bookingEndDate, "d", "[]")
          );
        }
      });
    }
  };

  mapAO = (ao, i, html, bookingStartDate, bookingEndDate, values) => {
    let dateInRange = this.mapAOPartA(ao, bookingStartDate, bookingEndDate);

    if (dateInRange) {
      if (ao.totalInventory > 0) {
        html.push(
          <div key={`addOn-${ao._id}`}>
            <div className="add-on">
              <FormikCheckboxCustom
                name="listing.addOns"
                label={`${ao.name} ($${ao.price})`} /* ` For Chrome debugging*/
                value={ao._id}
                onClick={() => this.checkBoxToggle(listing, ao, values)}
                checked={ao.show}
              />
              <p>{ao.description}</p>
              <PlusMinusNumberCustom
                className={`add-on ${ao.show ? "add-on-show" : "add-on-hide"}`}
                index={i}
                addOn={ao}
                key={`plus-minus-${i}`}
                name={`listings.addOns.${i}.name`}
                num={ao.inventoryToRemove}
                values={values}
                callBack={this.numberChangeInventory}
                minValue={1}
                maxValue={ao.inventory}
                incrementBy="1"
              />
            </div>
          </div>
        );
      } else {
        html.push(
          <div key={`addOn-${ao._id}`}>
            <div className="add-on">
              <FormikCheckboxCustom
                name="listing.addOns"
                label={`${ao.name} ($${ao.price})`} /* ` For Chrome debugging*/
                value={ao._id}
                onClick={() => this.checkBoxToggle(listing, ao, values)}
                checked={ao.show}
              />
              <p>{ao.description}</p>
            </div>
          </div>
        );
      }
    }
  };

  renderAddOns(listing, bookingStartDate, bookingEndDate, values) {
    let addOns = listing.addOns;
    if (!addOns) return null;

    const activeAddOns = addOns.filter((x) => x.isActive === true);

    if (!activeAddOns.length) return null;

    let html = [];
    html.push(
      <h6 key="addon-disclaimer">
        Would you like to purchase any rental add-ons to make your stay more
        enjoyable?
      </h6>
    );

    addOns
      .filter(
        (x) =>
          x.isActive === true && (x.inventory > 0 || x.totalInventory === 0)
      )
      .map((ao, i) => {
        this.mapAO(ao, i, html, bookingStartDate, bookingEndDate, values);
      });

    if (html.length === 1) return null;
    return html;
  }

  render() {
    let { booking, listing } = this.props;
    if (!booking.selectedBooking) return <div>Loading...</div>;
    if (!listing) return <div>Loading Listing data...</div>;
    let startDate = moment(booking.selectedBooking.startDate);
    let endDate = moment(booking.selectedBooking.endDate);
    let numDays = Math.ceil(endDate.diff(startDate, "days", true));

    let initialValues = {
      booking: booking.selectedBooking,
      listing: listing,
    };

    const listingImage = getListingImage(listing);

    return (
      <Formik
        onSubmit={this.onSubmit}
        initialValues={initialValues}
        enableReinitialize={true}
      >
        {({ values }) => (
          <Form>
            <div className="container listing-booking-overview">
              <div className="row">
                <div className="col">
                  <h2>Booking Overview</h2>
                </div>
              </div>
              <div className="row">
                {values.listing.photos.length > 0 && (
                  <div className="col-md-6 p-3 image-container">
                    <div
                      style={{
                        backgroundImage: `url(${listingImage})`,
                      }}
                    />
                  </div>
                )}
                <div className="col-md-6 p-3">
                  <div className="row">
                    <div className="col-12">
                      <h5>{values.listing.listingName}</h5>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 p-3">
                  <div className="col-12 pb-3">
                    <div className="details pb-2">Travel Dates</div>
                    <div>
                      <span className="font-weight-bold">
                        {startDate.format("M/D/YYYY")} -{" "}
                        {endDate.format("M/D/YYYY")}
                      </span>{" "}
                      ({numDays} night{numDays === 1 ? "" : "s"})
                    </div>
                  </div>
                  <div className="col-12 pb-3">
                    <div className="details pb-2">Number of Guests</div>
                    <PlusMinusNumber
                      name="guests"
                      num={values.booking.guests}
                      callBack={this.numberChange}
                      minValue="1"
                      incrementBy="1"
                    />
                  </div>
                  {values.listing.listingDetails.petsAllowed && (
                    <div className="col-12 pb-3">
                      <h6>Are you bringing pets?</h6>
                      <FormikRadioButton
                        name="booking.hasPets"
                        value={true}
                        label="Yes"
                      />
                      <FormikRadioButton
                        name="booking.hasPets"
                        value={false}
                        label="No"
                      />
                    </div>
                  )}
                  <div className="col-12 pb-3">
                    {this.renderAddOns(
                      values.listing,
                      startDate,
                      endDate,
                      values
                    )}
                  </div>
                </div>
              </div>
              <div className="button-row row">
                <div className="col text-center">
                  <label onClick={this.onBack}>Back</label>
                </div>
                <div className="col text-center">
                  <button type="submit">Next</button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

export default withRouter(connect(mapStateToProps)(BookingOptionsComponent));
